import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  key: 0,
  class: "custom-select__selected-value"
}
const _hoisted_3 = {
  key: 1,
  class: "custom-select__selected-value"
}
const _hoisted_4 = { class: "custom-select__options" }
const _hoisted_5 = ["value", "onClick"]

import { ref, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomSelector',
  props: {
  options: {
    type: Array,
    required: true,
  },
  selectedOption: {
    type: Object,
    required: true,
  },
  placeholder: {
    type: String,
  },
},
  emits: ['newSelected'],
  setup(__props, { emit: emits }) {

const props = __props;




const showDropdown = ref(false);
const customSelect = ref(null);

const sortedOptions = computed(() => {
  return Array.from(props.options).sort((a, b) => {
    if (a.price < b.price) {
      return -1;
    }
    if (a.price > b.price) {
      return 1;
    }

    if (a.price === b.price) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
    }

    return 0;
  });
});

function closeDropdown() {
  document.body.removeEventListener('click', closeDropdownOnOutsideClick, true);
  showDropdown.value = false;
}
function openDropdown() {
  document.body.addEventListener('click', closeDropdownOnOutsideClick, true);
  showDropdown.value = true;
}

function closeDropdownOnOutsideClick(ev) {
  if (ev.target !== customSelect.value) {
    closeDropdown();
  }
}
function toggleDropdown() {
  if (showDropdown.value) {
    closeDropdown();
  } else {
    openDropdown();
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['custom-select', { 'custom-select--open': showDropdown.value }]),
    onClick: _withModifiers(toggleDropdown, ["prevent","stop"]),
    ref_key: "customSelect",
    ref: customSelect
  }, [
    (__props.selectedOption)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.selectedOption.name), 1))
      : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.placeholder), 1)),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortedOptions), (option) => {
        return (_openBlock(), _createElementBlock("div", {
          key: option.id,
          value: option.id,
          class: _normalizeClass([
          'custom-select__option',
          {
            'custom-select__option--selected':
              __props.selectedOption && option.id === __props.selectedOption.id,
          },
        ]),
          onClick: _withModifiers(($event: any) => (emits('newSelected', option.id)), ["prevent","stop"])
        }, _toDisplayString(option.name), 11, _hoisted_5))
      }), 128))
    ], 512), [
      [_vShow, showDropdown.value]
    ])
  ], 10, _hoisted_1))
}
}

})